function getRouteFromHref(href: string): string {
  const path = href.split('?')[0]?.replace(/^\//, '') ?? ''
  const segments = path.split('/').filter(Boolean)

  if (segments[0]?.length === 2) {
    return segments.slice(1).join('/')
  }

  return segments.join('/')
}

export function hrefMatchesNavRoute(href: string, url: string): boolean {
  if (!href || !url) return false

  return getRouteFromHref(href) === url
}
